export default __webpack_public_path__ + "static/media/recepi.6edf4bbb.png";